"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Panel = require("react-bootstrap/lib/Panel");

var _Panel2 = _interopRequireDefault(_Panel);

var _IconKeyboardArrowRight = require("../Icons/IconKeyboardArrowRight");

var _IconKeyboardArrowRight2 = _interopRequireDefault(_IconKeyboardArrowRight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/** AccordionItem is merely a wrapper for <Panel> when used in conjuction with React-Bootstrap's <Accordion> component.
    AccordionItem accepts all Panel properties, except for "bsClass".
    See https://react-bootstrap.github.io/components/panel/#panels-accordion for implementation of Accordion.
*/
var AccordionItem = function AccordionItem(_ref) {
  var htmlId = _ref.htmlId,
      header = _ref.header,
      footer = _ref.footer,
      bodyRender = _ref.bodyRender,
      children = _ref.children,
      className = _ref.className,
      other = _objectWithoutProperties(_ref, ["htmlId", "header", "footer", "bodyRender", "children", "className"]);

  return _react2.default.createElement(
    _Panel2.default,
    Object.assign({ bsClass: "cx-accordion", id: htmlId, expanded: bodyRender }, other),
    _react2.default.createElement(
      "div",
      { className: className ? className : null },
      header && _react2.default.createElement(
        _Panel2.default.Heading,
        null,
        _react2.default.createElement(
          _Panel2.default.Title,
          { toggle: true },
          _react2.default.createElement(_IconKeyboardArrowRight2.default, null),
          _react2.default.createElement(
            "span",
            null,
            header
          )
        )
      ),
      _react2.default.createElement(
        _Panel2.default.Collapse,
        null,
        _react2.default.createElement(
          _Panel2.default.Body,
          null,
          children
        )
      ),
      footer && _react2.default.createElement(
        _Panel2.default.Footer,
        null,
        "footer"
      )
    )
  );
};

AccordionItem.propTypes = {
  bodyRender: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  footer: _propTypes2.default.node,
  header: _propTypes2.default.node,
  htmlId: _propTypes2.default.string.isRequired
};

exports.default = AccordionItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cx/ui/internal/AccordionItem.js
// module id = 579
// module chunks = 0